import Vue from 'vue'
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput, {
  preferredCountries: ['FI', 'SE', 'NO', 'DK', 'EE', 'RU'],
  inputClasses: 'form-control',
  mode: 'international',
  disabledFetchingCountry: true,
  validCharactersOnly: true
})